exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.offline {background-color: #ef4f4f;\n}\n.online {background-color: #1cde7b;\n}\n.busy {background-color: #e6c628;\n}\n.statusAgent { \n  height: calc(100% - 8px);\n  min-width: 2px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  margin-right: 4px;\n}\n.itemsListeAgent{padding-right: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheebox/WzWatcheeboxAgent.vue
// module id = C56l
// module chunks = 1